module.exports = __webpack_public_path__ + "static/media/chat-menu-accordion-toggle-open.00c28ce2.svg";